import React, { useMemo } from 'react';
import { Box, Button, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import FSGameCard from './FSGameCard';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import ErrorBoundary from '../../../components/material-ui/error_boundary/ErrorBoundary';
import { ENUM_FS_MODE_STATUS } from '../../../enums/enums';
export default function FSGameCards({
  gameCards,
  setGameCards,
  groupId,
  onSaveClick,
  changeRemoveGame,
  info
}) {
  const { t } = useTranslation();

  const cardList = Object.values(gameCards);
  const currency = info.currency;

  const saveDisable = useMemo(() => {
    if (!cardList.length) return true;
    if (!info.nameFs) return true;

    console.log('cardList', cardList);

    if (
      cardList?.some(
        (el) =>
          !el.freespins ||
          (!el.bet?.betId && +el.bet?.betId !== 0) ||
          el.status !== ENUM_FS_MODE_STATUS.available
      )
    ) {
      return true;
    }

    return false;
  }, [cardList]);

  const changeGameField = (gameId, value, fieldName) => {
    setGameCards((prev) => {
      const newObj = { ...prev };
      console.log('newObj', newObj);

      if (fieldName === 'betId') {
        const oldBet = newObj[gameId]?.bet || {};
        newObj[gameId] = { ...prev[gameId], bet: { ...oldBet, betId: value } };
      } else {
        newObj[gameId] = { ...prev[gameId], [fieldName]: value };
      }

      return newObj;
    });
  };

  const onCrossClick = (game) => {
    const gameId = game.gameId;
    setGameCards((prev) => changeRemoveGame(prev, gameId));
  };

  return (
    <Grid size={12}>
      <ShowContainer condition={Object.keys(gameCards).length}>
        <Stack display={'flex'} flexDirection={'column'} gap={1} mt={2}>
          <Grid container spacing={3}>
            {cardList?.map((game) => (
              <ErrorBoundary key={game.gameId}>
                <FSGameCard
                  game={game}
                  groupId={groupId}
                  currency={currency}
                  changeGameField={changeGameField}
                  onCrossClick={onCrossClick}
                />
              </ErrorBoundary>
            ))}
          </Grid>
          <Box mt={2} width={'100%'}>
            <Button
              variant="contained"
              fullWidth
              onClick={onSaveClick}
              size="large"
              disabled={saveDisable}>
              {t('Save')}
            </Button>
          </Box>
        </Stack>
      </ShowContainer>
    </Grid>
  );
}
